export default __webpack_public_path__ + "static/media/wedding_2.d279e417.jpg";